import Icon from '../components/Icon.vue'

Icon.register({
  bath: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M488 256c13.3 0 24 10.7 24 24v16c0 13.3-10.7 24-24 24h-8v32c0 28.4-12.4 54-32 71.5v32.5c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-8h-256v8c0 13.3-10.7 24-24 24h-16c-13.3 0-24-10.7-24-24v-32.5c-19.6-17.6-32-43.1-32-71.5v-32h-8c-13.3 0-24-10.7-24-24v-16c0-13.3 10.7-24 24-24h8v-144c0-44.1 35.9-80 80-80 27.2 0 51.3 13.7 65.7 34.5 21.9-6.1 46.2-1.1 64.2 15.4 4.7-4.2 11.9-4 16.4 0.5l11.3 11.3c4.7 4.7 4.7 12.3 0 17l-95 95c-4.7 4.7-12.3 4.7-17 0l-11.3-11.3c-4.5-4.5-4.7-11.7-0.5-16.4-21.5-23.5-23.3-57.8-6.8-83-5.7-8.9-15.7-14.9-27-14.9-17.6 0-32 14.4-32 32v144h408z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bath.js
// module id = 1022
// module chunks = 0